// ================================================================
// FILE: Ecommerce.tsx
// (route file for admin-menu/manage-thirdparty-services/payment-gateway/e-commerce —
// thin wrapper so the route config doesn't need to change)
// ================================================================
import ThirdPartyConnectForm from "./ThirdPartyConnectForm";

const Ecommerce = () => <ThirdPartyConnectForm />;

export default Ecommerce;
